import Repo from './Repo.js'

export default class CollectiveVacationRepository extends Repo {
  constructor () {
    super('collective-vacations')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  pdf (id, name = "Collective Vacation Decision") {
    return this.http.download(this.resource + "/" + id + "/pdf").then((response) => {
        let blob = new Blob([response.data], { type:   'application/pdf' } );
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name+'.pdf';
        link.click();
        return Promise.resolve(response);
    }).catch((response) =>{
            return Promise.reject(response);
    });
  }
}
